module.exports = __webpack_public_path__ + "img/CF_2Z.1e2d1d85.jpg";